import { useQuery } from '@tanstack/react-query';
import billingApi, { SubscriptionWithUsage } from '@/services/billingApi';

const SUBSCRIPTION_QUERY_KEY = 'subscription';

export function useSubscription() {
  return useQuery<SubscriptionWithUsage, Error>({
    queryKey: [SUBSCRIPTION_QUERY_KEY],
    queryFn: async () => {
      const res = await billingApi.getSubscription();
      if (!res.data.success) {
        throw new Error('Failed to load subscription');
      }
      return res.data.subscription;
    },
    retry: 1,
    staleTime: 2 * 60 * 1000,
  });
}
